import { observer } from "mobx-react-lite";

import { NodeColorGrid } from "@/components/doc/right-sidebar/node-viewer/NodeColorSelector";
import { setNodeColor } from "@/components/doc/right-sidebar/node-viewer/utils";
import { canSetColor } from "@/models/nodes/utils";

import type { DocumentModel } from "@/models/DocumentModel";
import type { TailwindColor } from "@/utils/tailwindColors";

type Props = {
  doc: DocumentModel;
  nodeId: string;
  close: () => void;
};

export const MathColorPopover = observer(function MathColorPopover({ doc, nodeId, close }: Props) {
  const node = doc.nodes.get(nodeId);

  if (!node || !canSetColor(node)) {
    return null;
  }

  const handleSelect = (color: TailwindColor) => {
    setNodeColor(node, color);
    close();
  };

  return <NodeColorGrid color={node.color} onSelect={handleSelect} />;
});
